module.exports = __webpack_public_path__ + "img/card-background.03e3676.png";